<template>
  <div>
    <a-card class="customer-header" size="small">
      <div>
        <a-page-header :title="getTitle" @back="() => $router.go(-1)" />
      </div>
      <div class="form-content">
        <a-spin :spinning="spinning">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item label="名称" prop="name">
                  <a-input ref="title" v-model="form.name" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="故障等级" prop="level">
                  <a-select v-model="form.level" placeholder="请选择故障等级">
                    <a-select-option v-for="(item, index) in faultLevels" :key="index" :value="item.value">
                      <a-tag :color="item.color"> {{ item.label }} </a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="关联业务域" prop="domains">
                  <a-select v-model="form.domains" mode="multiple" :max-tag-count="3" show-search placeholder="请选择关联业务域">
                    <a-select-option v-for="item in domainData" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="关联项目" prop="projects">
                  <a-select v-model="form.projects" mode="multiple" :max-tag-count="2" show-search placeholder="请选择关联项目" :filter-option="utils.filterOption">
                    <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="上报时间" prop="reported_time">
                  <a-date-picker v-model="form.reported_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="开始时间" prop="started_time">
                  <a-date-picker v-model="form.started_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="解决时间" prop="resolved_time">
                  <a-date-picker v-model="form.resolved_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="故障标签" prop="tags">
                  <a-select v-model="form.tags" mode="multiple" :max-tag-count="5" placeholder="请选择故障标签">
                    <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="复盘状态" prop="tags">
                  <a-select v-model="form.recap_status" :max-tag-count="5" placeholder="请选择复盘状态">
                    <a-select-option v-for="(item, index) in faultRecapStatus" :key="index" :value="item.value">
                      <a-tag :color="item.color"> {{ item.label }} </a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="复盘组织人" prop="tags">
                  <a-select v-model="form.recap_organizer" :max-tag-count="5" placeholder="请选择复盘组织人">
                    <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item label="故障描述" prop="process">
                  <vditor-editor v-model="form.process" :height="200" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="归因分析">
                  <vditor-editor v-model="form.attribution" :height="500" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
          <div style="text-align: center; margin-top: 16px">
            <a-button class="submit" type="primary" :loading="loading" @click="onSubmit()">提交</a-button>
          </div>
        </a-spin>
      </div>
    </a-card>
  </div>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { projectList } from '@/api/project/project';
import { problemDetail } from '@/api/event/problem';
import { domainBasicList } from '@/api/system/domain';
import { faultLevels, faultRecapStatus } from '@/utils/dictionary';
import { faultDetail, faultAdd, faultModify } from '@/api/event/fault';

import VditorEditor from '@/components/VditorEditor';

export default {
  components: { VditorEditor },
  data() {
    return {
      faultLevels,
      faultRecapStatus,
      loading: false,
      spinning: false,
      faultId: parseInt(this.$route.query.faultId) || null,
      problemId: parseInt(this.$route.query.problemId) || null,
      projects: [],
      domainData: [],
      defaultFileList: [],
      form: {
        name: null,
        tags: [],
        projects: [],
        domains: [],
        attribution: '##### 处理过程\nxx\n##### 定级依据\nxx\n##### 归因分析\nxx\n##### 改进措施\nxx\n'
      },
      rules: {
        name: [{ required: true, message: '故障名称不能为空', trigger: 'blur' }],
        level: [{ required: true, message: '故障等级不能为空', trigger: 'blur' }],
        domains: [{ required: true, message: '关联业务域不能为空', trigger: 'blur' }],
        process: [{ required: true, message: '处理过程不能为空', trigger: 'blur' }]
        // reason: [{ required: true, message: '定级依据不能为空', trigger: 'blur' }]
      },
      tagData: []
    };
  },
  computed: {
    getTitle() {
      return `${this.faultId === null ? '添加' : '编辑'}故障`;
    }
  },
  created() {
    if (this.faultId !== null) {
      this.getFaultDetail();
    }
    if (this.problemId !== null) {
      this.getProblemDetail();
    }
    this.getProjectList();
    this.getDomainList();
    this.getTagList();
  },

  methods: {
    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    // 获取业务域列表
    getDomainList() {
      domainBasicList({}).then(res => {
        this.domainData = res.data.items;
      });
    },

    // 获取标签列表
    getTagList() {
      tagList({ group_code: 'fault' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    // 获取故障详情
    getFaultDetail() {
      this.spinning = true;
      faultDetail({ id: this.faultId }).then(res => {
        const data = res.data;
        this.form = {
          title: data.title,
          level: data.level,
          projects: data.projects.map(p => {
            return p.id;
          }),
          domains: data.domains.map(d => {
            return d.id;
          }),
          tags: data.tags.map(t => {
            return t.id;
          }),
          reported_time: data.reported_time,
          started_time: data.started_time,
          resolved_time: data.resolved_time,
          reason: data.reason,
          process: data.process,
          attribution_analysis: data.attribution_analysis,
          improvements: data.improvements,
          enclosure: data.enclosure
        };
        this.spinning = false;
      });
    },

    // 获取问题详情
    getProblemDetail() {
      this.spinning = true;
      problemDetail({ id: this.problemId }).then(res => {
        const data = res.data;
        this.form = {
          title: data.name,
          level: data.level,
          projects: data.projects.map(p => {
            return p.id;
          }),
          reported_time: data.reported_time,
          started_time: data.started_time,
          resolved_time: data.resolved_time,
          process: data.content,
          reason: '',
          attribution_analysis: '',
          improvements: ''
        };
        this.spinning = false;
      });
    },

    // 点击提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.faultId === null) {
            // 添加故障
            faultAdd({ ...this.form, problem_id: this.problemId })
              .then(() => {
                this.loading = false;
                this.$router.go(-1);
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 编辑故障
            faultModify({ id: this.faultId, ...this.form })
              .then(() => {
                this.loading = false;
                this.$router.go(-1);
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.customer-header {
  .ant-divider-horizontal {
    margin: 8px 0px;
  }
  .ant-page-header {
    padding: 0;
  }
}
.form-content {
  width: 960px;
  margin: 16px auto;
}
/deep/.ant-form-item {
  margin-bottom: 0;
  .ant-form-item-label {
    line-height: 32px;
  }
}
.submit {
  width: 100px;
  margin: 0 auto;
}
</style>
